export default __webpack_public_path__ + "static/sunilWadhwa1-8d612cae02587aadebbef4a284818784.jpg";